﻿import { Utility } from "../Utility.js";
import Chart from "../../chart.js/dist/Chart.js"

export { Statistics };

/**
 * Class Statistics do mapa
 */
const Statistics = function () {
    // Define this
    var myStatistics = this;

    // -- begin private variable ------------------------------------------------------------------

    // Utility
    this._utility = new Utility();

    // Layer tree json
    this._layerTreeObj = null;

    // Layer info
    this._layerInfo = null;

    // charts (offcanvas and modal)
    var myChart = new Chart(document.getElementById("myChart").getContext('2d'));
    var myChartModal = new Chart(document.getElementById("myChartModal").getContext('2d'));

    //force to hidde spiner
    myStatistics._utility.ShowWait('spinner-statistics-background', false);

    // -- end private variable --------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    /**
     * Statistic init
     * @param {any} layerTreeJson, layer tree object
     * @param {any} layerInfo, layer info
     */
    this.Init = function (layerTreeJson, layerInfo) {
        var layerTreeJsonClone = {
            primaryKey: 'id',
            uiLibrary: 'materialdesign',
            //imageUrlField: 'img', //'legendUrl',
            dataSource: layerTreeJson.dataSource,
            checkboxes: false
        };

        // Get layer info of layer tree
        this._layerInfo = layerInfo;

        // Create layer tree statistics
        myStatistics._layerTreeObj = $('#layer-tree-statistic').tree(layerTreeJsonClone);

        // Event on select
        myStatistics._layerTreeObj.on('select', function (e, $node, record, state) {
            var layerIdSelected = record;

            // If not layer then leave.
            if (!layerInfo.dict_layer_info[layerIdSelected])
                return;

            // Fill id layer selected
            $('#layer-tree-statistic-id-layer').val(layerIdSelected);

            // Fill info layer selected

            // Fill column layer info
            var comboColumnLayer = [];

            for (var i = 0; i < layerInfo.dict_layer_info[layerIdSelected].list_column.length; i++) {
                var columnType = layerInfo.dict_layer_info[layerIdSelected].list_column[i].column_type;
                // only if it's string or numeric
                if (columnType === 'xsd:string' || columnType === 'xsd:int' || columnType === 'xsd:number') {
                    comboColumnLayer.push(layerInfo.dict_layer_info[layerIdSelected].list_column[i]);
                }
            }
            // fill combo
            myStatistics._utility.FillSelect('creation-statistcs-column-select', comboColumnLayer, 'pretty_name', 'column_name');
        });

        this.columnDefArrayDescriptiveStatistics = [];

        // statistics label
        this._objDef = {
            'data': 'statLabel',
            'title': 'Estatística descritiva',
            'name': 'statLabel',
            'label': 'statLabel',
            'type': 'readonly',
            'orderable': false,
            'width': '40%'
        };
        this.columnDefArrayDescriptiveStatistics.push(this._objDef);

        // statistics value
        this._objDef = {
            'data': 'statValue',
            'name': 'statValue',
            'label': 'statValue',
            'type': 'readonly',
            'orderable': false,
            'width': '60%'
        };
        this.columnDefArrayDescriptiveStatistics.push(this._objDef);

        // -- Table definition --
        this.datatableStatisticsResult = $('#offcanvas-statistics-table1').DataTable({
            "dom": '<rtip',
            "destroy": true,
            "language": {
                "emptyTable": 'Nenhum element encontrado'
            },
            "fixedHeader": true,
            "info": false,
            "scrollY": $('#offcanvas-statistics-table-zone1').height() - 27,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": false,
            "ordering": false,
            "columns": this.columnDefArrayDescriptiveStatistics,
            "initComplete": function (settings, json) {
                $('#offcanvas-statistics-table_scroll').height($('#offcanvas-statistics-table-zone1').css('max-height').replace('px', '') - 20);
            },
            "select": false,
            "name": "search_statistics_result",
            "rowId": 'id_evento_vli'
        });

        this.columnDefArrayHistogram = [];

        // statistics label
        this._objDef = {
            'data': 'statLabel',
            'title': 'Frequências',
            'name': 'statLabel',
            'label': 'statLabel',
            'type': 'readonly',
            'orderable': false,
            'width': '80%'
        };
        this.columnDefArrayHistogram.push(this._objDef);

        // statistics value
        this._objDef = {
            'data': 'statValue',
            'title': 'abs',
            'name': 'statValue',
            'label': 'statValue',
            'type': 'readonly',
            'orderable': false,
            'width': '10%'
        };
        this.columnDefArrayHistogram.push(this._objDef);

        // statistics value
        this._objDef = {
            'data': 'statPercentValue',
            'title': 'rel',
            'name': 'statPercentValue',
            'label': 'statPercentValue',
            'type': 'readonly',
            'orderable': false,
            'width': '10%'
        };
        this.columnDefArrayHistogram.push(this._objDef);

        // -- Table definition --
        this.datatableHistogram = $('#offcanvas-histogram-table2').DataTable({
            "dom": '<rtip',
            "destroy": true,
            "language": {
                "emptyTable": 'Nenhum element encontrado'
            },
            "fixedHeader": true,
            "info": false,
            "scrollY": $('#offcanvas-statistics-table-zone2').height() - 27,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": false,
            "ordering": false,
            "columns": this.columnDefArrayHistogram,
            "initComplete": function (settings, json) {
                $('#offcanvas-histogram-table_scroll').height($('#offcanvas-histogram-table-zone2').css('max-height').replace('px', '') - 20);
            },
            "select": false,
            "name": "search_histogram_result",
            "rowId": 'id_evento_vli'
        });
    };

    /**
     * Calculate statistics
     */
    this.CalculateStatistics = function () {
        // get values from combos
        var idLayer = $('#layer-tree-statistic-id-layer').val();
        var columnName = $('#creation-statistcs-column-select').val();
        var columnType = myStatistics._layerInfo.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).column_type;

        // vars for geoserver
        var geoserver = myStatistics._layerInfo.dict_layer_info[idLayer].layer_info.geoserver;
        var workspace = myStatistics._layerInfo.dict_layer_info[idLayer].layer_info.workspace;
        var layerName = myStatistics._layerInfo.dict_layer_info[idLayer].layer_info.layerName;
        var cqlFilter = null;

        var dataToStatistics = [];
        var ctx = document.getElementById("myChart");

        //var url = geoserver + '/' + workspace + '/ows?service=WFS&version=1.1.0&request=GetFeature'
        //    + '&typename=' + workspace + ':' + layerName;
        var url = geoserver + '/' + workspace + '/ows?service=WFS&version=1.1.0&request=GetFeature'
           + '&typename=' + workspace + ':' + layerName + '&propertyName=' + columnName;
        if (cqlFilter) {
            url += '&cql_filter=' + encodeURI(cqlFilter);
        }
        url += '&outputFormat=application/json' + '&format_options=CHARSET:UTF-8';

        var xhr = new XMLHttpRequest();
        xhr.open('GET', url);
        xhr.onload = function () {
            if (xhr.status === 200) {

                var dataJSON = JSON.parse(xhr.responseText);

                // extract wanted columnn from JSON
                for (i = 0; i < dataJSON.features.length; i++) {
                    dataToStatistics.push(eval('dataJSON.features[i].properties.' + columnName));
                }

                // sort raw data 
                if (columnType === 'xsd:string') {
                    dataToStatistics = dataToStatistics.sort();
                }
                else {
                    dataToStatistics = dataToStatistics.sort(function (a, b) { return a - b; });
                }

                // create hast containing data histogram
                var dataHistogram = {};
                for (var i = 0; i < dataToStatistics.length; ++i) {
                    // confirmar
                    if (dataToStatistics[i] === null) {
                        dataToStatistics[i] = "(em branco)";
                    }
                    if (!dataHistogram[dataToStatistics[i].toString()]) {
                        dataHistogram[dataToStatistics[i].toString()] = 0;
                    }
                    ++dataHistogram[dataToStatistics[i].toString()];
                }

                // sort hash into array of keys and array of values
                var chartLabel = Object.keys(dataHistogram).sort((a, b) => a - b);
                var chartData = [];
                for (var t = 0; t < chartLabel.length; t++) {
                    chartData.push(dataHistogram[chartLabel[t]]);
                }

                // limit X axle data labels to 20 chars 
                for (var i = 0; i < chartLabel.length; i++) {
                    if (chartLabel[i].length > 20) {
                        chartLabel[i] = chartLabel[i].substring(0, 20) + '...';
                    }
                }

                // if column is numeric
                var count;
                if (columnType === 'xsd:int' || columnType === 'xsd:number') {

                    // if (em branco) -> null
                    for (var j = 0; j < dataToStatistics.length; ++j) {
                        if (dataToStatistics[j] === "(em branco)") {
                            dataToStatistics[j] = null;
                        }
                    }
                    // calculate statistics
                    var max = parseFloat(Math.max.apply(Math, dataToStatistics).toFixed(3));
                    var min = parseFloat(Math.min.apply(Math, dataToStatistics).toFixed(3));
                    count = dataToStatistics.length;
                    var sum = parseFloat(dataToStatistics.reduce((a, b) => a + b, 0).toFixed(3));
                    var avg = parseFloat((sum / count).toFixed(3));
                    var median;
                    if (dataToStatistics.length % 2) median = parseFloat((dataToStatistics[Math.floor(dataToStatistics.length / 2)]).toFixed(3));
                    else median = parseFloat(((dataToStatistics[Math.floor(dataToStatistics.length / 2)] + dataToStatistics[Math.floor(dataToStatistics.length / 2)]) / 2.0).toFixed(3));
                    var squareDiffs = dataToStatistics.map(function (value) {
                        var diff = value - avg;
                        var sqrDiff = diff * diff;
                        return sqrDiff;
                    });
                    var stdDev = parseFloat(Math.sqrt((squareDiffs.reduce((a, b) => a + b, 0) / squareDiffs.length)).toFixed(3));

                    myStatistics.datatableStatisticsResult.clear().draw();
                    myStatistics.datatableStatisticsResult.row.add({ statLabel: 'Contagem', statValue: count });
                    myStatistics.datatableStatisticsResult.row.add({ statLabel: 'Minimo', statValue: min });
                    myStatistics.datatableStatisticsResult.row.add({ statLabel: 'Máximo', statValue: max });
                    myStatistics.datatableStatisticsResult.row.add({ statLabel: 'Soma', statValue: sum });
                    myStatistics.datatableStatisticsResult.row.add({ statLabel: 'Média', statValue: avg });
                    myStatistics.datatableStatisticsResult.row.add({ statLabel: 'Mediana', statValue: median });
                    myStatistics.datatableStatisticsResult.row.add({ statLabel: 'Desvio Padrão', statValue: stdDev });
                    myStatistics.datatableStatisticsResult.draw();
                    $('#offcanvas-statistics-table-zone1').css({ 'height': '170px' });
                }

                // column type is string
                else {
                    // create output for report - statistics
                    count = dataToStatistics.length;

                    myStatistics.datatableStatisticsResult.clear().draw();
                    myStatistics.datatableStatisticsResult.row.add({ statLabel: 'Contagem', statValue: count });
                    myStatistics.datatableStatisticsResult.draw();
                    $('#offcanvas-statistics-table-zone1').css({ 'height': '50px' });
                }

                myStatistics.datatableHistogram.clear().draw();
                for (var s = 0; s < chartLabel.length; s++) {
                    myStatistics.datatableHistogram.row.add({
                        statLabel: chartLabel[s],
                        statValue: chartData[s],
                        statPercentValue: ((chartData[s] / count) * 100).toFixed(2) + '%'
                    });
                }
                myStatistics.datatableHistogram.draw();

                // create random color for cheat bars
                var chartBackgroundColor = [];
                for (var u = 0; u < Object.entries(dataHistogram).length; u++) {
                    chartBackgroundColor[u] = '#' + Math.floor(Math.random() * 16777215).toString(16);
                }

                // clear charts
                if (myChart.data.datasets.length !== 0) {
                    myChart.data.labels.pop();
                    myChart.data.datasets.forEach((dataset) => { myChart.data.datasets.pop(); });
                    myChart.update();
                
                    myChartModal.data.labels.pop();
                    myChartModal.data.datasets.forEach((dataset) => { myChartModal.data.datasets.pop(); });
                    myChartModal.update();
                }

                myChart = new Chart(ctx, {
                    type: 'bar',
                    data: {
                        labels: chartLabel,
                        datasets: [{
                            label: 'Coluna: ' + columnName,
                            data: chartData,
                            backgroundColor: chartBackgroundColor,
                            borderColor: chartBackgroundColor,
                            borderWidth: 1
                        }]
                    },
                    options: {
                        title: {
                            display: true,
                            text: columnName
                        },
                        legend: {
                            display: false
                        },
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true,
                                    display: false
                                }
                            }],
                            xAxes: [{
                                ticks: {
                                    display: false
                                }
                            }]
                        }
                    }
                });

                var ctxModal = document.getElementById("myChartModal");
                myChartModal = new Chart(ctxModal, {
                    type: 'bar',
                    data: {
                        labels: chartLabel,
                        datasets: [{
                            label: 'Coluna: ' + columnName,
                            data: chartData,
                            backgroundColor: chartBackgroundColor,
                            borderColor: chartBackgroundColor,
                            borderWidth: 1
                        }]
                    },
                    options: {
                        title: {
                            display: true,
                            text: columnName
                        },
                        legend: {
                            display: false
                        },
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true,
                                    //display: false
                                }
                            }],
                            xAxes: [{
                                ticks: {
                                    //display: false
                                    fontSize: 10,
                                    autoSkip: false
                                }
                            }]
                        }
                    }
                });
            } else {
                onError();
            }
        };
        xhr.send();
        myStatistics._utility.ShowWait('spinner-statistics-background', false);
    };

    // -- end public method -----------------------------------------------------------------------

    // -- begin event -----------------------------------------------------------------------------

    /**
     *Event button click - Execute statistics
     */
    $('#creation-statistics-submit').on('click', function () {
        if ($('#layer-tree-statistic-id-layer').val() !== "" && $('#creation-statistcs-column-select').val() !== "") {
            // Show spiner on search
            myStatistics._utility.ShowWait('spinner-statistics-background', true);
            $('#layer-tree-statistic-zone').css({ 'display': 'none' });
            $('#border-statistics-combo-not-combo-layer').css({ 'display': 'block' });
            // alterar o app.sgs.Map
            $('#statistics-selected-layer').text(app.sgs.Map.layerTree.layerInfo.dict_layer_info[$('#layer-tree-statistic-id-layer').val()].layer_info.text);
            $('#offcanvas-statistics-data-and-graph').css({ 'display': 'block' });
            $('#offcanvas-statistics-data-and-graph-graph').css({ 'display': 'block' });
            myStatistics.CalculateStatistics();
        }
    });

    $('#border-statistics-combo-not-combo-layer').on('click', function () {
        $('#layer-tree-statistic-zone').css({ 'display': 'block' });
        $('#border-statistics-combo-not-combo-layer').css({ 'display': 'none' });
        $('#offcanvas-statistics-data-and-graph-graph').css({ 'display': 'none' });
        $('#offcanvas-statistics-data-and-graph').css({ 'display': 'none' });
    });

    $('#myChart').on('click', function () {
        if (!myStatistics._utility.mobilecheck()) {
            // remove statistics side canvas
            myStatistics._utility.ShowOpenCanvas3('offcanvas-statistics', false);
            // display modal 
            $('#modal-statistics-graph').css({ 'display': 'block' });
            $('#modal-myChart').css({ 'height': '500px', 'width': '750px' });
        }
    });

	$('#modal-myChart').on('click', function () {
        myStatistics._utility.ShowOpenCanvas3('offcanvas-statistics', true);
        $('#modal-statistics-graph').css({ 'display': 'none' });
        $('#myChart').appendTo('#offcanvas-statistics-data-and-graph-graph');
    });

    // -- end event -------------------------------------------------------------------------------
};